import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'
import update from 'immutability-helper'

const initialState = {
  contacts: [],
  company: {
    company: {},
    companyActiveDeals: [],
    companyActiveProposals: [],
    companyClosedDeals: [],
    companyLostProposals: [],
    companyLostDeals: [],
    companyProjectDeals: [],
    companyWonDeals: [],
    companyWonProposals: [],
    companyPipeline: {}
  },
  notes: [],
  tasks: [],
  name: ''
}

const companyReducer = createReducer(initialState, {
  [ACT.COMPANY_CONTACTS_FETCH_SUCCESS](state, action) {
    const { contacts } = action.payload
    return {
      ...state,
      contacts
    }
  },
  [ACT.COMPANY_FETCH_SUCCESS](state, action) {
    const { company } = action.payload
    return {
      ...state,
      company
    }
  },
  [ACT.CONTACT_CREATE_SUCCESS](state, action) {
    const { contact } = action.payload
    return update(state, {
      contacts: { $push: [contact] }
    })
  },
  [ACT.COMPANY_UPDATE_SUCCESS](state, action) {
    const { company } = action.payload
    return update(state, {
      company: {
        company: { $set: company }
      }
    })
  },
  [ACT.COMPANY_NOTES_FETCH_SUCCESS](state, action) {
    const { notes } = action.payload

    return update(state, {
      notes: { $set: notes }
    })
  },
  [ACT.COMPANY_ADD_NOTE_SUCCESS](state, action) {
    const { note } = action.payload

    return update(state, {
      notes: { $unshift: [note] }
    })
  },
  [ACT.COMPANY_UPDATE_NOTE_SUCCESS](state, action) {
    const { note, noteId } = action.payload
    const index = state.notes.findIndex(note => note.id === noteId)

    return update(state, {
      notes: {
        [index]: { $set: { ...note } }
      }
    })
  },
  [ACT.COMPANY_DELETE_NOTE_SUCCESS](state, action) {
    const { noteId } = action.payload

    return update(state, {
      notes: { $set: state.notes.filter(n => n.id !== noteId) }
    })
  },
  [ACT.COMPANY_TASKS_FETCH_SUCCESS](state, action) {
    const { tasks, companyName } = action.payload
    return {
      ...state,
      tasks,
      name: companyName || state.name
    }
  },

  [ACT.CREATE_COMPANY_TASK_SUCCESS](state, action) {
    const { tasks } = action.payload
    return update(state, {
      tasks: { $push: tasks }
    })
  },

  [ACT.COMPANY_TASK_MARK_COMPLETED_SUCCESS](state, action) {
    const { task } = action.payload
    const index = state.tasks.findIndex(t => t.id === task.id)
    return update(state, {
      tasks: {
        [index]: { $set: task }
      }
    })
  },

  [ACT.UPDATE_COMPANY_TASK_SUCCESS](state, action) {
    const { task } = action.payload
    const index = state.tasks.findIndex(t => t.id === task.id)
    return update(state, {
      tasks: {
        [index]: { $set: task }
      }
    })
  },

  [ACT.DELETE_COMPANY_TASK_SUCCESS](state, action) {
    const { task } = action.payload
    const index = state.tasks.findIndex(t => +t.id === task.id)

    return update(state, {
      tasks: {
        $splice: [[index, 1]]
      }
    })
  }
})

export default companyReducer
